// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__y8JSk","inputWrap":"Table_inputWrap__32Wxz","col":"Table_col__CBQ6V","bmiTooltip":"Table_bmiTooltip__cPrCL"};